import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect, useState, Suspense } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'assets/styles/singleWork.css';
import 'assets/styles/slider.css';
import Router from 'routes/routes';
import CallBackModal from './components/common/CallBackModal';
import ScrollToTop from './components/common/ScrollTop';
import theme from './theme';
import DefaultFooter from 'components/DefaultFooter';

const App: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const PreLoad: React.ReactElement = (
    <div className="h-screen w-100 flex items-center justify-center ">
      <h3 className="text-osperb-blue">Osperb</h3>
    </div>
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={PreLoad}>
        <CallBackModal
          showModal={showModal}
          setShowModal={setShowModal}
          isApp
          isGallery={false} // or true depending on context
          image={null}
        />
        <ScrollToTop />

        <Router />
        <DefaultFooter />
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
